// extracted by mini-css-extract-plugin
export default {"Invoices":"Invoices_Invoices__8vmKp","InvoicesList":"Invoices_InvoicesList__nJ9ST","InvoicesHeader":"Invoices_InvoicesHeader__Jk0g6"};